import React, { forwardRef } from "react";

import { SEOVideoObject } from "./SEOVideoObject";
import { useSubtitles } from "../hooks/useSubtitles";
import PropTypes from "prop-types";
import { useOrcaCommonContext } from "../contexts/OrcaCommonContext";
import { useTransitionToVideo } from "../hooks/useTransitionToVideo";
import { useHandleVideoStart } from "../hooks/useHandleVideoStart";
import { OrcaCommonUI } from "./OrcaCommonUI";
import { CommonControls } from "../../controls/CommonControls";

export const OrcaLoopingUI = forwardRef(
  (
    { onVideoRendered = () => {}, config = {}, handleVideoEnd = () => {} },
    ref
  ) => {
    const { playCallback = () => {}, isCarousel = false } = config;

    const { setRenderControls, play, autoplay } = useOrcaCommonContext();

    const transitionToVideo = useTransitionToVideo({
      setRenderControls,
      isCarousel,
      autoplay,
      play,
      playCallback
    });

    const { hasSubtitles, updateCues, currentCue, setupSubtitlesListener } =
      useSubtitles();

    const handleStart = useHandleVideoStart(
      transitionToVideo,
      config,
      setupSubtitlesListener
    );

    return (
      <>
        <OrcaCommonUI
          onVideoRendered={onVideoRendered}
          config={config}
          promoEnabled={false}
          liveEventEnded={false}
          handleVideoEnd={handleVideoEnd}
          isLive={false}
          handleStart={handleStart}
          transitionToVideo={transitionToVideo}
          updateCues={updateCues}
          hasSubtitles={hasSubtitles}
          currentCue={currentCue}
          ref={ref}
          Controls={CommonControls}
        />
        <SEOVideoObject />
      </>
    );
  }
);

OrcaLoopingUI.displayName = "OrcaLoopingUI";

OrcaLoopingUI.propTypes = {
  onVideoRendered: PropTypes.func,
  config: PropTypes.object,
  handleVideoEnd: PropTypes.func
};
